module.exports = __webpack_public_path__ + "img/logo.1ce3a05d.svg";